export default "__VITE_ASSET__df4b7e2b__"